import logger from "@/utils/logger";

export default async function getProductDetailsFromClient(mpId: number): Promise<ProductDetails | null> {
  try {
    const data = await fetch(`/rest/neo/pdp/${mpId}`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    const response = (await data.json()) as ProductDetails;

    return {
      ...response,
      url: response.url.indexOf("/") !== 0 ? `/${response.url}` : data.url,
    };
  } catch (error) {
    logger.error(error);
    return null;
  }
}
